export enum LadingErrorStatus {
    ChoXuLy= 1,
    DaXuLy = 2
}
